module.exports = { "default": require("core-js/library/fn/number/is-integer"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ../~/.6.11.6@babel-runtime/core-js/number/is-integer.js
// module id = 84
// module chunks = 0